import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewLstLotesWinmanga = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'lst_lotes_winmanga', // Cambiar
        name: 'Gestión Lotes de Winmanga', // Cambiar
        component: ViewLstLotesWinmanga,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
